/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addInstrumentDenylistEntry} from '../api'

export const useMutationAddInstrumentDenylistEntry = createReactQueryMutationHook('addInstrumentDenylistEntry', addInstrumentDenylistEntry)
